import { render, staticRenderFns } from "./PatientPlan.vue?vue&type=template&id=4ea54206&scoped=true&"
import script from "./PatientPlan.vue?vue&type=script&lang=ts&"
export * from "./PatientPlan.vue?vue&type=script&lang=ts&"
import style0 from "./PatientPlan.vue?vue&type=style&index=0&id=4ea54206&lang=scss&scoped=true&"
import style1 from "./PatientPlan.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea54206",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VForm,VRow,VSpacer})
